const doc = [({"zh_cn":({"buttonActivity":({"addRoom":"增加经验", "backToHotel":"返回体验预约页面", "backToRoomList":"返回体验列表", "removeRoom":"删除体验", "roomDetail":"体验详情"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;